<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="left">
            </div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <ons-toolbar-button v-on:click="$router.go(-1)">
                    <i class="fal fa-times"/>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content main-background">
            <div class="content-inner content-inner-fill">
                <template v-if="packages">
                    <div class="main-header">Licenses</div>
                    <p>Goodeats uses the following Open Source packages:</p>
                    <v-ons-list>
                        <v-ons-list-item v-for="pkg in packages" v-bind:key="pkg.name">
                            <div class="center">
                                <span class="list-item__title">{{ pkg.name }}</span>
                                <span class="list-item__subtitle">
                                    <span v-if="helpers.stringEmpty(pkg.author) == false">By {{ pkg.author }} -</span>
                                    {{ pkg.license }}
                                </span>
                            </div>
                      </v-ons-list-item>
                    </v-ons-list>
                </template>
            </div>
        </div>

    </v-ons-page>
</template>

<script>
export default {
    name: "licenses",

    data() {
        return {
            app: this.$root.$data.app,
            packages: null,
        }
    },

    mounted() {
        fetch('/licenses.json')
            .then(response => response.json())
            .then(data => this.packages = data);
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/licenses.vue